var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetoneira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.634,
    height: 22.451,
    viewBox: "0 0 34.634 22.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    "data-name": "Grupo 388",
    transform: "translate(-194.143 -165.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M228.259,180.652h-.138v-.277q0-2.6,0-5.194a3.541,3.541,0,0,0-.124-.98,3.325,3.325,0,0,0-3.273-2.4c-1.891-.007-3.781,0-5.672,0-.044,0-.09,0-.139.007a5.817,5.817,0,0,0-.179-.982,3.042,3.042,0,0,0-1.587-2.275c-.082-.038-.155-.091-.234-.135a24.925,24.925,0,0,0-11.968-3.119,28.724,28.724,0,0,0-8.312,1.133,1.587,1.587,0,0,0-.709.409,5.877,5.877,0,0,0-1.613,3.137,10.066,10.066,0,0,0,.017,3.73,1.5,1.5,0,0,0,.437.975,27.292,27.292,0,0,0,3.575,2.748c-1.389.344-2.926.74-2.926.74a.518.518,0,0,0-.518.518v5.528a.518.518,0,0,0,.518.518h.854c.018-.057.036-.109.05-.163a3.819,3.819,0,0,1,3.724-2.911c2.131-.012,4.263-.017,6.394,0a3.828,3.828,0,0,1,3.767,3.083h8.188c.111,0,.207.019.25-.146a3.863,3.863,0,0,1,7.5-.017c.035.133.083.167.21.166.765,0,1.529,0,2.294,0a.926.926,0,0,0,.135-.019V181.17A.518.518,0,0,0,228.259,180.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M239.749,241.731a2.6,2.6,0,1,0,2.662,2.608A2.614,2.614,0,0,0,239.749,241.731Z",
    transform: "translate(-33.265 -59.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M211.745,241.758a2.592,2.592,0,1,0,2.655,2.578A2.622,2.622,0,0,0,211.745,241.758Z",
    transform: "translate(-11.575 -59.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M310.2,241.758a2.592,2.592,0,1,0,2.662,2.577A2.6,2.6,0,0,0,310.2,241.758Z",
    transform: "translate(-87.814 -59.205)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetoneira);
export default __webpack_public_path__ + "static/media/betoneira.a7c7f987426fdd435a8d368b936bb65d.svg";
export { ForwardRef as ReactComponent };